import React, { useEffect, useState } from 'react';
import KenSelect from '../../global_components/KenSelect';
import { Grid, Paper, Button, makeStyles } from '@material-ui/core';
import {
  getCourseVersion,
  getDataForCourseEnrolment,
  filterSessionGetData,
  getCourseEvaluationComponentByCourseOfferingId,
  getCourseEvaluationSubcomponentByComponentId,
} from '../../Utils/apiServices';
import KenLoader from '../KenLoader';

const useStyles = makeStyles((theme) => ({
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    height: '28px',
    width: '78px',
    marginTop: '10px',

    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
}));

export default function Filters(props) {
  const {
    term,
    courseoff,
    CourseVersion,
    setMaximumnumber,
    CourseEvaluationComponent,
    SubComponent,
    setCourseID,
    value,
    handleSectionChange,
    setSelectedID,
    sessionFeedback,
    setSubComponentData,
    subComponentData,
    handleCourseEvaluation,
    handleSubComponentChange,
    sessionFilter,
    setSessionData,
    setsessionID,
    sessionID,
    selectedSection,
    setstudentData,
    setSectionData,
    sectionId,
  } = props;
  const classes = useStyles();
  const userDetails = localStorage.getItem('userDetails');
  const [loading, setLoading] = React.useState(false);
  const [selectDepartmentOption, setDepartmentOption] = useState([]);
  const [selectProgramOption, setProgramOption] = useState([]);
  const [selectTermOption, setTermOption] = useState([]);
  const [department, setDepartment] = useState('');
  const [filterData, setFilterData] = useState([]);
  const [programPlan, setProgramPlan] = useState('');
  const [termValue, setTermValue] = useState('');
  const [CourseVersionOption, setCourseVersionOption] = useState([]);
  const [course, setCourse] = useState([]);
  const [courseOffering, setcourseOffering] = useState('');

  const [CourseVersionSelect, setCourseVersionSelect] = useState('');
  const [CourseVersionFilter, setCourseVersionFilter] = useState([]);
  const [CourseOfferFilter, setCourseOfferFilter] = useState([]);
  const [CourseOfferOption, setCourseOfferOption] = useState([]);
  const [trigger, setTrigger] = useState(false);
  const [section, setSection] = useState('');
  const [courseData, setCourseData] = useState([]);
  const [courseEvalutionopt, setCourseEvalutionopt] = useState([]);
  const [subComponentOpt, setSubComponentOpt] = useState([]);
  const [sessionDataOptions, setsessionDataOptions] = useState([]);

  const handleSelectChange2 = () => {
    setDepartment('');
    setProgramOption([]);
    setProgramPlan('');
    setTermOption([]);
    setTermValue('');
    setCourseVersionOption([]);
    setCourse('');
    setCourseOfferOption([]);
    setcourseOffering('');
    setCourseEvalutionopt([]);
    setsessionDataOptions([]);
    {
      setSelectedID && setSelectedID('');
    }
    {
      setCourseID && setCourseID('');
    }
    {
      setSessionData && setSessionData([]);
    }
    {
      setstudentData && setstudentData([]);
    }
    {
      setSectionData && setSectionData([]);
    }
  };
  useEffect(() => {
    // setLoading(true);
    const data = JSON.parse(userDetails);
    const instituteId = data?.Id;
    getDataForCourseEnrolment(instituteId).then((res) => {
      var AcademicOption = [];
      // AcademicOption.push(
      //   {
      //     label: "-select-",
      //     value: ""
      //   }
      // );

      const dataS = Object.entries(res?.AcdemicProgramsForEachDepartment);
      dataS[0][1].map((items) => {
        AcademicOption.push({
          label: items.AcademicProgramName,
          value: items.AcademicProgramId,
        });
      });
      // dataS[1][1].map((items) => {
      //   AcademicOption.push({
      //     label: items.AcademicProgramName,
      //     value: items.AcademicProgramId,
      //   });
      // });
      // dataS[2][1].map((items) => {
      //   AcademicOption.push({
      //     label: items.AcademicProgramName,
      //     value: items.AcademicProgramId,
      //   });
      // });
      setDepartmentOption(AcademicOption);
      setFilterData(res);
      setLoading(false);
    });
  }, [userDetails]);

  const handleChangeDepartment = (e) => {
    setDepartment(e.target.value);
    const ProgramOption = [];
    const dataS = Object.entries(
      filterData.ProgramPlanForEachAcedemicProgram
    ).filter((item) => {
      if (item[0] === e.target.value) {
        return item;
      } else {
        return false;
      }
    });
    if (dataS.length > 0) {
      dataS[0][1].map((items) => {
        ProgramOption.push({
          label: items.ProgramPlanName,
          value: items.ProgramPlanId,
        });
      });
    }
    setProgramPlan('');
    setTermValue('');
    setCourse([]);
    setTermOption([]);
    setCourseOfferOption([]);
    setcourseOffering([]);
    setCourseVersionOption([]);
    setProgramOption(ProgramOption);
  };

  const handleChangeProgramPlan = (e) => {
    setProgramPlan(e.target.value);
    const TermOption = [];
    const dataS = Object.entries(filterData.TermForEachProgramPlan).filter(
      (item) => {
        if (item[0] === e.target.value) {
          return item;
        } else {
          return false;
        }
      }
    );
    if (dataS.length > 0) {
      dataS[0][1]?.map((items) => {
        TermOption.push({
          label: items.TermName,
          value: items.TermId,
        });
      });
    }
    setTermValue('');
    setCourse([]);
    setcourseOffering([]);
    setCourseOfferOption([]);
    setTermOption(TermOption);
  };

  const handleChangeTerm = (e) => {
    setTermValue(e.target.value);
    setTrigger(!trigger);
    const CourseVersionTermOption = [];
    setLoading(true);
    getCourseVersion(e.target.value).then((res) => {
      const dataS = Object.entries(res);
      setCourseVersionFilter(dataS);

      dataS[0][1]?.map((items) => {
        CourseVersionTermOption.push({
          label: items.courseName,
          value: items.courseId,
        });
      });
      setLoading(false);
      setCourseVersionOption(CourseVersionTermOption);
      setCourse('');
      setcourseOffering('');

      console.log('Course', dataS[0][1]);
    });
  };

  const handleChangeCourseversion = (e) => {
    if (setCourseID) {
      setCourseID(e.target.value);
    }
    setCourse(e.target.value);
    setCourseOfferOption([]);
    setCourseOfferFilter([]);
    setSection('');
    setcourseOffering('');
    console.log(' CourseVersionFilter[0][1]', CourseVersionFilter[0][1]);
    setCourseVersionSelect(e.target.value);
    CourseVersionFilter[0][1].filter((items) => {
      if (items.courseId === e.target.value) {
        setCourseOfferFilter(items.courseOffering);
      }
    });
  };

  useEffect(() => {
    const courseOffering = [];
    CourseOfferFilter.map((item) => {
      courseOffering.push({
        label: item.courseSectionId,
        value: item.id,
      });
      console.log('push', courseOffering);

      setSection(item.id);
    });
    setCourseOfferOption(courseOffering);
  }, [CourseOfferFilter]);

  const handleSectionChange1 = (e) => {
    if (setSelectedID) {
      setSelectedID(e.target.value);
    }
    console.log('section id', e.target.value);
    setcourseOffering(e.target.value);

    if (CourseEvaluationComponent) {
      setLoading(true);
      getCourseEvaluationComponentByCourseOfferingId(e.target.value)
        .then((res) => {
          setCourseData(res.data);
          setLoading(false);
          console.log(res.data);
        })
        .catch((err) => {
          console.log('Err: ', err);
          setLoading(false);
        })
        .catch((err) => {
          console.log('Err: ', err);
          setLoading(false);
        });
    }
    if (sessionFilter) {
      setLoading(true);
      filterSessionGetData(e.target.value)
        .then((res) => {
          setsessionDataOptions(
            res.data.map((item) => {
              return {
                label: item.sessionName,
                value: item.id,
              };
            })
          );

          setSessionData(res.data);
          setLoading(false);
        })
        .catch((error) => {});
    }
  };
  useEffect(() => {
    if (selectedSection) {
      setcourseOffering(selectedSection);
    }
  }, [selectedSection]);
  const handleCourseEvaluation1 = (e) => {
    console.log('component id', e.target.value);
    setLoading(true);
    getCourseEvaluationSubcomponentByComponentId(e.target.value)
      .then((res) => {
        setSubComponentData(res);
        setMaximumnumber(res[0].maxMarksForSubcomponent);
        setLoading(false);
        console.log(res);
      })
      .catch((err) => {
        console.log('Err: ', err);
        setLoading(false);
      });
  };

  useEffect(() => {
    const CourseEvaluation = [];
    courseData?.map((items) => {
      CourseEvaluation.push({
        label: items.componentName,
        value: items.id,
      });
    });

    setCourseEvalutionopt(CourseEvaluation);
  }, [courseData]);
  const handleSessionChange = (e) => {
    setsessionID(e.target.value);
  };

  useEffect(() => {
    const SubComponent = [];
    subComponentData?.map((items) => {
      SubComponent.push({
        label: items.name,
        value: items.id,
      });
    });

    setSubComponentOpt(SubComponent);
  }, [subComponentData]);

  return (
    <Paper style={{ marginTop: '15px', padding: '20px' }}>
      <Grid container md={12} spacing={2}>
        {loading && <KenLoader />}
        {term && (
          <Grid item xs={3}>
            <KenSelect
              required={true}
              options={selectDepartmentOption}
              label={'Academic Program'}
              value={department}
              onChange={(e) => {
                handleChangeDepartment(e);
              }}
            />
          </Grid>
        )}
        {term && (
          <Grid item xs={3}>
            <KenSelect
              required={true}
              options={selectProgramOption}
              label={'Intake'}
              value={programPlan}
              onChange={(e) => {
                handleChangeProgramPlan(e);
              }}
            />
          </Grid>
        )}
        {term && (
          <Grid item xs={3}>
            <KenSelect
              required={true}
              options={selectTermOption}
              label={'Term'}
              value={termValue}
              onChange={(e) => {
                handleChangeTerm(e);
              }}
            />
          </Grid>
        )}

        {CourseVersion && (
          <Grid item xs={3}>
            <KenSelect
              required={true}
              options={CourseVersionOption}
              label={'Course'}
              value={course}
              onChange={(e) => {
                handleChangeCourseversion(e);
              }}
            />
          </Grid>
        )}
        {courseoff && (
          <Grid item xs={3}>
            <KenSelect
              required={true}
              options={CourseOfferOption}
              label={sessionFeedback ? 'Course Offering' : 'Section'}
              value={sectionId ? sectionId : courseOffering}
              onChange={(e) => {
                handleSectionChange
                  ? handleSectionChange(e)
                  : handleSectionChange1(e);
              }}
            />
          </Grid>
        )}
        {CourseEvaluationComponent && (
          <Grid item xs={3}>
            <KenSelect
              required={true}
              options={courseEvalutionopt}
              label={'CourseEvaluation'}
              value={value}
              onChange={(e) => {
                handleCourseEvaluation
                  ? handleCourseEvaluation(e)
                  : handleCourseEvaluation1(e);
              }}
            />
          </Grid>
        )}
        {SubComponent && (
          <Grid item xs={3}>
            <KenSelect
              required={true}
              options={subComponentOpt}
              label={'Subcomponent'}
              value={value}
              onChange={(e) => {
                handleSubComponentChange(e);
              }}
            />
          </Grid>
        )}
        {sessionFilter && (
          <Grid item xs={3}>
            <KenSelect
              required={true}
              options={sessionDataOptions}
              label={'Session'}
              value={sessionID}
              onChange={(e) => {
                handleSessionChange(e);
              }}
            />
          </Grid>
        )}
        <Grid item xs={3}>
          <Button
            variant="contained"
            color="primary"
            className={classes.addButton}
            onClick={handleSelectChange2}
          >
            Clear All
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
}
